import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { DashboardService } from '~/service/service.dashboard';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';
import { DashboardCard } from '~/view/dashboard/dashboard.card';
import { DashboardCountriesChart } from '~/view/dashboard/dashboard.countries';
import { DashboardTitle } from '~/view/dashboard/dashboard.title';
import { DashboardTopButton } from '~/view/dashboard/dashboard.top';
import { DashboardUsersShelvesDialog } from '~/view/dialog/dialog.dashboard.users.shelves';
import { AsyncView } from '~/view/view.async';
import { Col } from '~/view/view.box';

export const DashboardGeneralPage = observer(() => {
	// const t = useTr(['dashboard']);
	const [ui, svc] = useService(UIService, DashboardService);
	ui.usePageTitle('Dashboard General');
	svc.useGeneral();

	return (
		<AsyncView async={svc.asyncGeneral}>
			<Col flex={1} justifyContent="flex-start" gap={2} py={2}>
				<Grid container spacing={2}>
					<Grid item xs={12} lg={6} display={'flex'} flexDirection={'column'} gap={2}>
						<DashboardTitle>Users</DashboardTitle>
						<Grid container spacing={2} wrap="wrap">
							{svc.generalUsersData.map(d => (
								<Grid item sm={12} md={4} lg={6} key={d.key}>
									<DashboardCard title={d.key} currValue={d.value} percent={d.percent} />
								</Grid>
							))}
						</Grid>
						<DashboardTitle>Base</DashboardTitle>
						<Grid container spacing={2} wrap="wrap">
							{svc.generalBaseData.map(d => (
								<Grid item sm={12} md={4} lg={6} key={d.key}>
									<DashboardCard title={d.key} currValue={d.value} percent={d.percent} />
								</Grid>
							))}
						</Grid>
					</Grid>
					<Grid item xs={12} lg={6}>
						<DashboardCountriesChart countries={svc.generalCountriesData} height={572} />
					</Grid>
				</Grid>
				<DashboardTitle>UGC</DashboardTitle>
				<Grid container spacing={2} wrap="wrap">
					{svc.generalUGCData.map(d => (
						<Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={d.key}>
							<DashboardCard title={d.key} currValue={d.value} percent={d.percent} />
						</Grid>
					))}
				</Grid>
				<DashboardTitle>TOP</DashboardTitle>
				<Col gap={2} p={2} color="grey.800">
					<DashboardTopButton onClick={() => ui.showDialog(DashboardUsersShelvesDialog)}>
						TOP 20 users by number of fragrances on shelves
					</DashboardTopButton>
					<DashboardUsersShelvesDialog />
				</Col>
			</Col>
		</AsyncView>
	);
});
